(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("creditCardModal", Handler);

	function Handler(swurveyAdminService, swurveysStageConfig) {

		var identityId, callback, theToken;

		var stripeHandler = StripeCheckout.configure({
			key: swurveysStageConfig.getConfigPropertyValue("stripe_publishable_key"),
			image: 'https://app.swurveys.com/images/swurveys_card.png',
			locale: 'auto',
			token: onTokenReceived,
			closed : onClosed
		});

		function onTokenReceived(token) {
			// You can access the token ID with `token.id`.
			// Get the token ID to your server-side code for use.
			theToken = token;
			console.log("Claiming token:", token);
			swurveyAdminService.addPaymentInstrument(identityId, token.id, callback);
		}
		
		function onClosed() {
			if(!theToken)
			  callback({message : "You must enter a valid credit card number"});
		}

		function show(_identityId, _callback) {

			identityId = _identityId;
			callback = _callback;

			stripeHandler.open({
				name: 'Swurveys',
				description: 'Associate your card with your account.',
				panelLabel : "You Will Not Be Charged",
				zipCode: true,
				amount: 0,
				allowRememberMe : false
			});
		}

		return {
			show: show
		};
	}
}());
